











import { defineComponent, onMounted, reactive, toRefs, watch } from '@vue/composition-api';
import Steps from '@/components/Steps/index';

export default defineComponent({
  name: 'FinancingEdit',
  components: {
    Steps
  },
  setup(props: any, { root }) {
    const state: any = reactive({
      stepArray: [
        {top: '第一步', bottom: '选择融资单据'},
        {top: '第二步', bottom: '填写融资基本信息'},
        {top: '第三步', bottom: '确认信息提交单据'},
      ],
      stepsActive: '1',
    });
    onMounted(()=>{
      state.stepsActive = root.$route.meta?.active ;
    });
    watch(()=> root.$route, ()=>{
      state.stepsActive = root.$route.meta?.active ;
    });

    return {
      ...toRefs(state)
    };
  },
});
